import script from "./GroupedAdvanceTransaction.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupedAdvanceTransaction.vue?vue&type=script&setup=true&lang=ts"

import "./GroupedAdvanceTransaction.vue?vue&type=style&index=0&id=122fc68c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122fc68c"]])

export default __exports__